export const cashColors = {
  black: "#000000",
  green: "#00D64F", // primary
  red: "#D3040E", // errors
  yellow: "#FFB600", // warnings
  blue: "#00C5F0", // info
  gray10: "#101010",
  gray40: "#808080",
  gray60: "#959595",
  gray80: "#CCCCCC",
  gray90: "#E5E5E5",
  gray96: "#F5F5F5",
  gray97: "#FAFAFA",
  white: "#FFFFFF",
};
